import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import { CreateAiCourseResultFragmentDoc } from '../../contentLibrary/CourseOutlineCanvasDialog.generated';
import { CreateAiOutlineResultFragmentDoc } from '../../contentLibrary/CreateAiOutlineResult.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ClientFacingWorkflowFragment = { __typename?: 'ClientFacingWorkflow', id: string, type: Types.ClientFacingWorkflowType, status: Types.ClientFacingWorkflowStatus, createdAt: string, result?: { __typename?: 'ClientFacingWorkflowResult', id: string, libraryItem?: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', en: string }, course?: { __typename?: 'Course', id: number, draftVersion: { __typename?: 'CourseVersion', id: number }, libraryItem: { __typename?: 'LibraryItem', id: string } } | null, skill?: { __typename?: 'Skill', id: number, draftVersion?: { __typename?: 'SkillVersion', id: string } | null, libraryItem: { __typename?: 'LibraryItem', id: string } } | null } | null } | null };

export type ClientFacingWorkflowQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;


export type ClientFacingWorkflowQuery = { __typename?: 'Query', ClientFacingWorkflow?: { __typename?: 'ClientFacingWorkflow', id: string, type: Types.ClientFacingWorkflowType, status: Types.ClientFacingWorkflowStatus, createdAt: string, result?: { __typename?: 'ClientFacingWorkflowResult', id: string, libraryItem?: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', en: string }, course?: { __typename?: 'Course', id: number, draftVersion: { __typename?: 'CourseVersion', id: number }, libraryItem: { __typename?: 'LibraryItem', id: string } } | null, skill?: { __typename?: 'Skill', id: number, draftVersion?: { __typename?: 'SkillVersion', id: string } | null, libraryItem: { __typename?: 'LibraryItem', id: string } } | null } | null } | null } | null };

export const ClientFacingWorkflowFragmentDoc = gql`
    fragment ClientFacingWorkflow on ClientFacingWorkflow {
  id
  type
  status
  createdAt
  result {
    id
    libraryItem {
      id
      name {
        en
      }
      course {
        ...CreateAICourseResult
      }
      skill {
        ...CreateAiOutlineResult
      }
    }
  }
}
    ${CreateAiCourseResultFragmentDoc}
${CreateAiOutlineResultFragmentDoc}`;
export const ClientFacingWorkflowDocument = gql`
    query ClientFacingWorkflow($id: UUID!) {
  ClientFacingWorkflow(id: $id) {
    ...ClientFacingWorkflow
  }
}
    ${ClientFacingWorkflowFragmentDoc}`;

/**
 * __useClientFacingWorkflowQuery__
 *
 * To run a query within a React component, call `useClientFacingWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientFacingWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientFacingWorkflowQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientFacingWorkflowQuery(baseOptions: Apollo.QueryHookOptions<ClientFacingWorkflowQuery, ClientFacingWorkflowQueryVariables> & ({ variables: ClientFacingWorkflowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientFacingWorkflowQuery, ClientFacingWorkflowQueryVariables>(ClientFacingWorkflowDocument, options);
      }
export function useClientFacingWorkflowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientFacingWorkflowQuery, ClientFacingWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientFacingWorkflowQuery, ClientFacingWorkflowQueryVariables>(ClientFacingWorkflowDocument, options);
        }
export type ClientFacingWorkflowQueryHookResult = ReturnType<typeof useClientFacingWorkflowQuery>;
export type ClientFacingWorkflowLazyQueryHookResult = ReturnType<typeof useClientFacingWorkflowLazyQuery>;
export type ClientFacingWorkflowQueryResult = Apollo.QueryResult<ClientFacingWorkflowQuery, ClientFacingWorkflowQueryVariables>;